import React, { forwardRef } from 'react'
import styled from 'react-emotion'
import Text from './Text'
import { color, space3, space4, space8, space2 } from '../style'
import { Link } from 'react-router-dom'
import Label from './Label'
import cavet from '../../media/img/icons/cavet.png'
import { Field, ErrorMessage } from 'formik'
import { useTranslation } from 'react-i18next'

const Form = styled('form')({
  label: 'Form',
  width: '100%',
  maxWidth: 540,
  padding: '0 20px',
  margin: '0 auto'
})

export const FormHeader = styled('h5')({
  label: 'FormHeader',
  color: color.grey,
  fontSize: 16,
  fontWeight: 500,
  marginTop: space4,
  marginBottom: space8
})

export const FormFieldset = styled.div({
  label: 'FormFieldset',
  marginTop: space4,
  marginBottom: space4
})

export const FormInputLabel = styled(
  forwardRef((props, ref) => <Text grey as="label" innerRef={ref} {...props} />)
)({
  label: 'FormInputLabel',
  display: 'block',
  marginTop: space4,
  marginBottom: space3,
  fontSize: 12
})

export const FormError = ({ name }) => {
  const { t } = useTranslation()
  return (
    <ErrorMessage name={name}>
      {message => (
        <FormLabel grey xLarge align="left">
          <Text red>{t(message)}</Text>
        </FormLabel>
      )}
    </ErrorMessage>
  )
}
const commonStyles = ({ invalid } = {}) => ({
  width: '100%',
  color: invalid && color.red,
  marginTop: space2,
  marginBottom: space2,

  '&:focus': { borderColor: color.black }
})

export const FormInput = styled(
  forwardRef(({ invalid, ...props }, ref) => (
    <Label xLarge as="input" innerRef={ref} {...props} />
  ))
)(props => ({
  label: 'FormInput',
  ...commonStyles(props),
  background: props.disabled && color.greyBlock
}))

export const FormikFormInput = forwardRef((props, ref) => (
  <FormInput as={Field} innerRef={ref} {...props} />
))

export const FormLabel = styled(
  forwardRef(({ invalid, ...props }, ref) => (
    <Label xLarge innerRef={ref} {...props} />
  ))
)(props => ({ label: 'FormLabel', ...commonStyles(props) }))

export const FormButton = styled(
  forwardRef((props, ref) => (
    <Label
      xLarge
      interactive
      as={props.to ? Link : props.href ? 'a' : 'button'}
      innerRef={ref}
      {...props}
    />
  ))
)(props => ({ label: 'FormButton', ...commonStyles(props) }))

export const FormRow = styled.div({
  label: 'FormRow',
  display: 'flex',
  '& > *': {
    // Columns
    flex: 1,

    // Spacing beteen
    '&:not(:first-child)': { marginLeft: space2 },
    '&:not(:last-child)': { marginRight: space2 },

    // Because we are now in flex formatting context margins will not
    // collapse - we need to remove them from first & last child in each col
    '& > :first-child': { marginTop: 0 },
    '& > :last-child': { marginBottom: 0 }
  }
})

const arrowSize = 10
export const FormSelect = styled(
  ({ className, onChangeValue, stretch, reverse, ...props }) => {
    if (onChangeValue) {
      props.onChange = e =>
        onChangeValue(e.target.options[e.target.selectedIndex].value)
    }
    return <Label xLarge as="select" className={className} {...props} />
  }
)(props => ({
  label: 'FormSelect',
  ...commonStyles(props),
  cursor: 'pointer',
  appearance: 'none', // stop safari making it all roundy

  // new down arrow
  background: `url('${cavet}') no-repeat`,
  backgroundSize: arrowSize,
  backgroundPosition: 'right 20px  center'
}))

export default Form
